export default __webpack_public_path__ + "5f5cb363d1ddccbf2c664a4782fea4b9.webp";